// Realtime Database set() rejects undefined. Detail routes often have no
// meta.dataPath, so Recents/Favourites used to send collection: undefined.

export function normalizeSettingsList(value) {
    if (Array.isArray(value)) return [...value];
    if (value && typeof value === "object") return Object.values(value);
    return [];
}

export function omitUndefinedFields(entry) {
    if (!entry || typeof entry !== "object" || Array.isArray(entry)) return {};
    const clean = {};
    for (const [key, value] of Object.entries(entry)) {
        if (value !== undefined) clean[key] = value;
    }
    return clean;
}

export function hasSettingsIdentity(entry) {
    if (!entry || typeof entry !== "object") return false;
    const { path, id } = entry;
    return path !== undefined && path !== null && path !== ""
        && id !== undefined && id !== null && id !== "";
}

export function buildSettingsEntry(fields) {
    return omitUndefinedFields(fields);
}

export function sanitizeSettingsList(list) {
    return normalizeSettingsList(list)
        .map((item) => omitUndefinedFields(item))
        .filter(hasSettingsIdentity);
}

export function sameSettingsEntry(item, { collection, id, path }) {
    if (!item) return false;
    if (collection && id) {
        return item.collection === collection && item.id === id;
    }
    return item.path === path;
}
